import { getManagerOpportunitiesRoute } from "@verivest/shared-components";
import React from "react";
import { useHistory } from "react-router";
import {
  InvestorPortalEmptyStatus,
  InvestorPortalEmptyStatusProps,
} from "../../InvestorPortalEmptyStatus";

export const DocumentsEmptyStatusView: React.FC<
  InvestorPortalEmptyStatusProps
> = (props) => {
  const history = useHistory();

  return (
    <InvestorPortalEmptyStatus
      imgSrc={"/images/investor-portal/empty-status/white-label/documents.svg"}
      title="You have no documents available"
      subTitle={
        "Once you make your first investment, your documents will appear here."
      }
      buttonLabel={"View opportunities"}
      buttonOnClick={() => history.push(getManagerOpportunitiesRoute())}
      {...props}
    />
  );
};
